import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import Auth from '../services/Auth';
import styled from 'styled-components'
import { getTheme } from '../global/utils'
import Heading from '../components/text/Heading'
import Card from '../components/cards/Card'
import CardHeader from '../components/cards/CardHeader'
import InputField from '../components/forms/InputField'
import Checkbox from '../components/forms/Checkbox'
import Alert from '../components/shared/Alert'
import Button from '../components/buttons/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import logo from '../img/logo.svg'
import loginBg from '../img/login-bg.jpg'
import loginBg2 from '../img/login-bg2.jpg'
import loginBg3 from '../img/login-bg3.jpg'
import loginBg4 from '../img/login-bg4.jpg'

let bgImages = [loginBg, loginBg2, loginBg3, loginBg4];
let max = bgImages.length - 1;
let randImg = Math.round(Math.random() * max);
let loginBgImg = bgImages[randImg];


const auth = new Auth();

const LoginLayout = styled.div`
  background: linear-gradient(
    -180deg,
    ${getTheme('bg', 'primary')} 0%,
    ${getTheme('bg', 'secondary')} 100%
  );
  @supports (background-blend-mode: multiply) {
    & {
      background: url(${loginBgImg}) no-repeat center center,
        linear-gradient(
          -180deg,
          ${getTheme('bg', 'primary')} 0%,
          ${getTheme('bg', 'secondary')} 100%
        );
      background-blend-mode: multiply;
      background-attachment: fixed;
    }
  }
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .login__card {
    width: 100%;
    max-width: 24rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    overflow: hidden;

    @media (max-width: 700px) {
      width: calc(100% - 4rem);
      margin-left: auto;
      margin-right: auto;
    }
    @media (max-height: 650px) and (orientation: landscape) and (min-width: 700px) {
      max-width: 40rem;
      .card__content {
        display: flex;
        > :first-child {
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-bottom: 0;
        }
      }
    }
  }

  .login__logo {
    margin-bottom: ${getTheme('spacer', 'l')};
    display: block;
    @media (max-height: 650px) and (orientation: landscape) {
      max-width: 80%;
    }
  }
  @media (max-height: 650px) and (orientation: landscape) {
    form {
      flex-shrink: 0;
      margin-left: ${getTheme('spacer', 's')};
    }
  }
  @media (min-width: 700px) and (max-height: 650px) and (orientation: landscape) {
    form {
      width: 16rem;
    }
  }
  form > :last-child {
    margin-bottom: 0;
  }
`

class Login extends Component {
    constructor() {
        super();

        this.state = {
            loginError: false,
            serverError: false,
            errorMessage: '',
            user: '',
            password: ''
        };
        this.checkFieldUser = this.checkFieldUser.bind(this);
        this.checkFieldPass = this.checkFieldPass.bind(this)

    }

    checkFieldUser(event) {
        this.setState({ user: event.target.value });
        this.setState({ errorMessage: ''})
    };

    checkFieldPass(event) {
        this.setState({ password: event.target.value });
        this.setState({ errorMessage: ''})
    };

    handleSubmit = e => {
       e.preventDefault();
       const userData = {
            username: this.state.user,
            password: this.state.password,
        };

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        let error='unknown';
        let responseStatusCode = '';
        let responseDataMessage = ''

        axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
        axios.defaults.xsrfCookieName = "csrftoken";
        axios.defaults.withCredentials = true;
        axios.post(process.env.REACT_APP_API_SERVER +'/login/', userData, headers )
            .then(res => {
                auth.startSession(res.data.rol, res.data.project);
                this.props.history.push('/');
            })
            .catch(err => {
                if (err && err.response && err.response.status && err.response.data && err.response.data.message) {
                    responseStatusCode = err.response.status;
                    responseDataMessage = err.response.data.message;
                    if (responseStatusCode < 500) {
                        error = 'loginerror';
                    } else {
                        error = 'servererror';
                    }
                }
                if (error === 'loginerror') {
                    this.setState({
                        loginError: true,
                        errorMessage: (<Alert error="true">{responseDataMessage}</Alert>)
                    })
                } else if (error === 'servererror') {
                    this.setState({
                        serverError: true,
                        errorMessage: (<Alert error="true">Server error. Please try again later.</Alert>)
                    })
                } else {
                    this.setState({
                        serverError: true,
                        errorMessage: (<Alert error="true">Unkown error. Please try again later.</Alert>)
                    })
                }
                //this.state.user.focus();
            })
    };

    render() {
        if (auth.isAuthenticated()) {
          return <Redirect to="/" />
        }

        const buttonDisabled = (
            this.state.user.length <3 ||
            this.state.password.length <5
        );
        return <LoginLayout>
            <Card className="login__card">
                <CardHeader branded>
                    <img
                        src={logo}
                        alt="CAF - Aunia Friendly Tool Set"
                        className="login__logo"
                    />
                    <Heading level="heading1">
                        <h1>Welcome back</h1>
                    </Heading>
                    <Heading level="heading6">
                        <h2>Please login to your account</h2>
                    </Heading>
                </CardHeader>
                <form
                    method="post"
                    onSubmit={e => {
                        this.handleSubmit(e)
                    }}
                >
                    {this.state.errorMessage}
                    <InputField
                        type="text"
                        name="username"
                        label="User name"
                        autoFocus
                        inputBlock
                        value={this.state.user}
                        onChange={this.checkFieldUser}
                        maxLength="25"
                    />
                    <InputField
                        type="password"
                        name="password"
                        label="Password"
                        inputBlock
                        value={this.state.password}
                        onChange={this.checkFieldPass}
                        maxLength="25"
                    />
                    <Button
                        size="medium"
                        iconBefore={<FontAwesomeIcon icon={faCheck}/>}
                        disabled={buttonDisabled}
                    >
                        enter
                    </Button>
                    <Checkbox label="Remember me" size="medium"/>
                </form>
            </Card>
         </LoginLayout>
    }
}

export default Login



// WEBPACK FOOTER //
// ./src/pages/Login.js